





















import Vue from "vue";
import { authService } from "@/common/services/AuthService";
import FirebaseSignIn from "@/common/components/FirebaseSignIn.vue";
import TheAppBar from "@/menu/components/TheAppBar.vue";
import { accessService } from "@/common/services/AccessService";
import { Paths, RouteInfoMap } from "@/common/enums/RouterPaths";
import { storeService } from "@/common/services/StoreService";
import { DateTime } from "luxon";

export default Vue.extend({
  name: "Dashboard",

  components: {
    TheAppBar,
    FirebaseSignIn,
  },
  data() {
    return {
      authService: authService,
    };
  },
  async beforeMount() {
    if (!accessService.hasAccessToDashboard()) {
      await this.$router.push({
        name: RouteInfoMap.get(Paths.ClickAndCollect)?.name,
        query: {
          storeId: storeService.selectedStore.toString(),
          date: DateTime.now().toFormat("yyyy-MM-dd"),
        },
      });
    }
  },
});
